import React from "react";
import * as Styles from "./styles/NavigationStepStyles";
import { TradeInAemLabel } from "../../../../utils/labels";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../../redux/store";
import { getNavStepsConfigs } from "../../../../utils/navUtils";
import { useTradeInCsl } from "../../../../csl/tradeInCslUtils";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { useDispatch } from "../../../../../shared-logic/redux/store";

const TradeInAemNavigationItemsMobile = (): JSX.Element => {
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const currentStep = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const csl = useTradeInCsl();

    const stepList = csl.enabledNavSteps;
    const navStepsConfigs = getNavStepsConfigs(csl, currentStep, stepList, dispatch, commonSettings);

    return (
        <Styles.Wrapper>
            {navStepsConfigs.map((step) => (
                <Styles.Link onClick={step.onClick} key={step.label}>
                    <Styles.Step isActive={currentStep === step.type}>
                        <div>
                            <Styles.Badge className="build-badge" isActive={currentStep === step.type}>
                                0{step.stepCount}
                            </Styles.Badge>
                            <TradeInAemLabel label={step.label} />
                        </div>
                        <IconWrapper iconColor={currentStep === step.type ? "primaryBlack" : "grey3"}>
                            <Icon variant="chevronRight" />
                        </IconWrapper>
                    </Styles.Step>
                </Styles.Link>
            ))}
        </Styles.Wrapper>
    );
};

export default TradeInAemNavigationItemsMobile;
